import { useMutation } from '@tanstack/react-query';
import { getLead } from '../services/lead';
import { ILeadEntity } from '@rasayi-workspace/shared';
import { useLeadContext } from '@contexts';

export const useExistingLead = (leadId: string, isStore: boolean) => {
    
    const { setUpdatingLeadEntity } = useLeadContext();
    const {
        mutate: fetchExistingLead,
        isLoading,
        isError,
        data
    } = useMutation<ILeadEntity>({
        mutationKey: ['fetchLead', leadId],
        mutationFn: async () => getLead(leadId),
        onSuccess: item => {
          if(isStore)  setUpdatingLeadEntity(item);
        },
    });
    

    return {
        fetchExistingLead,
        isLoading,
        isError,
        data
    };
};
